<pos-app-spinner [show]="loading"></pos-app-spinner>
<div [formGroup]="printerSelectorForm">
  <div class="modal-header">
    <h4 class="modal-title">Select Printer to Print Pick Slip</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-2 pt-2"><label>Select Printer:</label></div>
      <div class="col-6 pt-2 mx-2">
        <ng-select placeholder="Select Printer" formControlName="selectedPrinter" style="width: 100%">
          <ng-option *ngFor="let printer of printerList" [value]="printer.printerRole">
            <span class="pr-1">{{ printer.printerDescription }} -</span>
            {{ printer.printerRole }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-flex float-end justify-content-end">
      <button class="btn btn-cancel float-right" (click)="handleCloseModel()">CANCEL</button>
      <button class="btn btn-save float-right text-uppercase" (click)="updatePrinter()" [disabled]="!formValid">
        {{ 'Print' }}
      </button>
    </div>
  </div>
</div>
